export const siteInfo = {
  brand: "海角爆",
  brandFull: "海角爆料",
  slogan: "新鲜快讯 · 实时跟进 · 吃瓜追更",
  desc: "海角爆料是专注新鲜快讯与热门事件实时更新的娱乐资讯门户，今日快讯、实时动态、热门事件进展第一时间同步。",
  email: "hello@capbao.example",
  since: 2021,
  navCategories: ["热点", "娱乐", "影视", "综艺", "科技圈", "生活"],
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "热点", path: "/#hot" },
  { label: "娱乐", path: "/#ent" },
  { label: "影视", path: "/#film" },
  { label: "综艺", path: "/#variety" },
  { label: "关于", path: "/about" },
  { label: "FAQ", path: "/faq" },
];